// Controls system for Space Invaders
export class Controls {
  constructor() {
    this.keys = {};
    this.setupKeyboardControls();
    this.setupMobileControls();
  }

  setupKeyboardControls() {
    window.addEventListener('keydown', e => {
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', ' ', 'a', 'd', 'A', 'D'].includes(e.key)) {
        e.preventDefault();
      }
      this.keys[e.key.toLowerCase()] = true;
    });

    window.addEventListener('keyup', e => {
      this.keys[e.key.toLowerCase()] = false;
    });

    // Reset input helpers when window loses focus
    window.addEventListener('blur', () => {
      this.keys['arrowleft'] = false;
      this.keys['arrowright'] = false;
      this.keys['a'] = false;
      this.keys['d'] = false;
      this.keys[' '] = false;
    });
  }

  setupMobileControls() {
    const leftBtn = document.getElementById('leftBtn');
    const rightBtn = document.getElementById('rightBtn');
    const shootBtn = document.getElementById('shootBtn');

    if (leftBtn) {
      leftBtn.addEventListener('touchstart', e => {
        e.preventDefault();
        this.keys['arrowleft'] = true;
      }, { passive: false });
      leftBtn.addEventListener('touchend', e => {
        this.keys['arrowleft'] = false;
      }, { passive: false });
    }

    if (rightBtn) {
      rightBtn.addEventListener('touchstart', e => {
        e.preventDefault();
        this.keys['arrowright'] = true;
      }, { passive: false });
      rightBtn.addEventListener('touchend', e => {
        this.keys['arrowright'] = false;
      }, { passive: false });
    }

    if (shootBtn) {
      shootBtn.addEventListener('touchstart', e => {
        e.preventDefault();
        this.keys[' '] = true;
        setTimeout(() => this.keys[' '] = false, 100);
      }, { passive: false });
    }
  }

  isPressed(key) {
    return this.keys[key.toLowerCase()] || false;
  }

  isMovingLeft() {
    return this.isPressed('arrowleft') || this.isPressed('a');
  }

  isMovingRight() {
    return this.isPressed('arrowright') || this.isPressed('d');
  }

  isShooting() {
    return this.isPressed(' ') || this.isPressed('space');
  }

  resetShootHandled() {
    this.keys._spaceHandled = false;
  }

  setShootHandled() {
    this.keys._spaceHandled = true;
  }

  isShootHandled() {
    return this.keys._spaceHandled || false;
  }
}
